// src/components/RouteErrorBoundary.js
//
// Catches a render-time crash in a route subtree and shows the actual error +
// component stack on screen (instead of a blank page). Intentionally BRIGHT and
// loud so it can't be mistaken for a blank/black screen.

import React from 'react';

export default class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    // eslint-disable-next-line no-console
    console.error('[RouteErrorBoundary]', error, info && info.componentStack);
  }

  render() {
    const { error, info } = this.state;
    if (error) {
      const msg = String((error && (error.stack || error.message)) || error);
      return (
        <div
          style={{
            padding: 24,
            minHeight: '100vh',
            background: '#ffffff',
            color: '#111111',
            fontFamily: 'system-ui, sans-serif',
            overflow: 'auto',
          }}
        >
          <h1 style={{ color: '#b00020', marginTop: 0 }}>⚠ This screen crashed — here is the error</h1>
          <p style={{ color: '#444' }}>Copy the red box below (and the gray stack) and send it back.</p>
          <pre
            style={{
              background: '#fff3f3',
              color: '#b00020',
              padding: 16,
              fontSize: 14,
              border: '2px solid #b00020',
              borderRadius: 8,
              whiteSpace: 'pre-wrap',
              overflow: 'auto',
            }}
          >
            {msg}
          </pre>
          <h3 style={{ color: '#333' }}>Component stack</h3>
          <pre
            style={{
              background: '#f3f3f3',
              color: '#333',
              padding: 12,
              fontSize: 12,
              whiteSpace: 'pre-wrap',
              overflow: 'auto',
            }}
          >
            {info && info.componentStack}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}
